/**
 * Native disclosure block (**`details`**) for optional long copy.
 *
 * @param options - **`summary`** line and expandable **`body`** text.
 * @returns **`HTMLDetailsElement`** with **`qz-disclosure`** styling.
 */
export function createDisclosure(
  options: Readonly<{
    summary: string;
    body: string;
  }>,
): HTMLDetailsElement {
  const det = document.createElement("details");
  det.className = "qz-disclosure";

  const sum = document.createElement("summary");
  sum.className = "qz-disclosure__summary";
  sum.textContent = options.summary;

  const body = document.createElement("div");
  body.className = "qz-disclosure__body";
  body.textContent = options.body;

  det.appendChild(sum);
  det.appendChild(body);
  return det;
}
